<template>
  <v-dialog content-class="custom-dialog" ref="dlgKelas" v-model="dialog" retain-focus max-width="700">
    <template v-slot:activator="{}"></template>

    <v-card class="elevation-0 pa-5" style="position:relative">
      <v-row class="lg-mt-5" v-if="infoKelas">
        <v-col cols="12" sm="12" md="12" lg="12" class="px-5">
          <div>
            <span class="title">Info terbaru!!</span>
            <p class="headline primary--text my-1">Hi, {{ current_user.nama }}</p>
            <p class="py-1">
              Hampir setengah juta JP dalam belasan ribu sertifikat sudah bisa diunduh bagi peserta yang menuntaskan Bimtek angkatan 1 pada program ini.
            </p>
            <div class="body-1 py-2" v-if="infoKelas.is_publik">
              Saat ini Anda belum menuntaskan
              <strong>{{ infoKelas.nama }}</strong
              >. Ayo segera tuntaskan agar bisa mengikuti Bimtek dan Diklat serta dapatkan eSertifikatnya.
            </div>
            <div class="body-1" v-else>
              Saat ini Anda belum menuntaskan
              <strong>{{ infoKelas.nama }}</strong
              >. Ayo segera tuntaskan sebelum tanggal
              <strong>{{ infoKelas.tanggal_akhir | toDT }}</strong>
              <br />
              <p class="py-2">
                Tuntaskan belajar dan dapatkan sertifikat Anda disini.
              </p>
            </div>
          </div>
          <div class="my-2"></div>
          <div>
            <p>
              Salam Guru Belajar<br />
              Terima Kasih
            </p>
          </div>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :small="$vuetify.breakpoint.xs" text color="primary--text" @click="dialog = false">Saya Mengerti</v-btn>
        <m-button :small="$vuetify.breakpoint.xs" color="orange white--text" textButton="Tuntaskan" action="toCourse" @toCourse="toCourse(infoKelas)"></m-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { PASSPORT } from "@/const";
export default {
  data() {
    return {
      dialog: false
    };
  },
  props: {
    infoKelas: {
      type: Object,
      default: null
    }
  },

  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    toCourse(val) {
      var courseWindow = window.open("", "_blank");
      courseWindow.location.href = PASSPORT + val.link_learndash;
    }
  }
};
</script>
